import axios from "axios";

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: "http://localhost:8000/",
  baseURL: "https://prd-cloud.agvperu.com/"
  // baseURL: "https://www.agvperu.com/backend",
  //baseURL: 'http://127.0.0.1:8000/' // Local,
  // baseURL: "http://52.55.68.217/backend", // QAS,
  //baseURL: "https://etlagro.agvperu.com/backend_etl/",
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
});

export default axiosIns;
